<template>
  <div style="background-color: #edf4fc;">
    <div style="min-height: 5rem;">
      <div style="padding: 0.06rem;font-size: 0.13rem;">
        <div>
          <h3 style="text-align: center;color: #000;font-size: 25px;">{{ contentData.title }}</h3>
        </div>
        <div>
          <div style="color: #000;" class="itemConten ql-editor" v-html="contentData.content"></div>
        </div>
        <div>
          <span style="color: #000;float: right;padding-top: 4px;padding-right: 10px;font-size: 20px;">{{ contentData.time }}</span>
          <span style="color: #000;float: right;font-size: 20px;">时间：</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 按需导入 API 接口
import { selectMessage } from '@/api/departmentAPI'

import '@/assets/quill.snow.css'

export default {
  name: 'Article',
  data() {
    return {
      contentData: {}
    }
  },
  created() {
    this.titleContent()
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  watch: {
    // 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件即可
    $route: 'titleContent'
  },
  methods: {
    async titleContent () {
      const { data: res } = await selectMessage(this.$route.params.id)
      if (res.code === 200) {
        this.contentData = res.data
      } else {
        this.$message({
          message: '查找内容失败',
          type: 'warning'
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a p div span {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
</style>
